var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailEnvelopeClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.158 17.1839C2.34911 18.7232 3.59267 19.9393 5.13542 20.1005C7.27018 20.3237 9.48267 20.5593 11.75 20.5593C14.0173 20.5593 16.2298 20.3237 18.3645 20.1005C19.9073 19.9393 21.1508 18.7232 21.3419 17.1839C21.5701 15.3461 21.7946 13.4455 21.7946 11.4999C21.7946 9.55445 21.5701 7.65382 21.3419 5.816C21.1508 4.27667 19.9073 3.06063 18.3645 2.89937C16.2298 2.67622 14.0173 2.44058 11.75 2.44058C9.48267 2.44058 7.27017 2.67622 5.13542 2.89937C3.59267 3.06063 2.34911 4.27667 2.158 5.816C1.92982 7.65382 1.70532 9.55445 1.70532 11.4999C1.70532 13.4455 1.92982 15.3461 2.158 17.1839Z",
    fill: "#84C70D",
    fillOpacity: 0.35,
    stroke: "#84C70D",
    strokeWidth: 2.41071,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20288 5.39984L9.75985 11.3583C10.927 12.2785 12.573 12.2785 13.7401 11.3583L21.2971 5.39984",
    stroke: "#84C70D",
    strokeWidth: 2.41071,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailEnvelopeClose);
export default __webpack_public_path__ + "static/media/mail-envelope-close.626c5e4762681d09c3fa00a83a5a4ea3.svg";
export { ForwardRef as ReactComponent };